import React, { useEffect } from "react";
import { get } from "lodash";
import AsyncGet from "../../../components/Materials/AsyncGet";

import style from './style.module.css';

const RenderCount = ({ data, loadFromAPI }) => {
    let intervalTimeout = null;
    useEffect(() => {
        clearTimeout(intervalTimeout);

        setInterval(() => {
            loadFromAPI();
        }, 10000);

        return (() => {
            clearTimeout(intervalTimeout);
        });
    }, []);
    return (
        <>
            {
                get(data, 'count', 0) > 0 && <div className={style.count}>
                    <span>{get(data, 'count', 0)}</span>
                </div>
            }
        </>
    )
}

const Count = ({ isNotificationOpen = true }) => {
    return (
        <AsyncGet
            url="/notification/count"
            loadOnMount={true}
            key={isNotificationOpen}
            permissionText="Notification Count"
            render={({ data, loadFromAPI }) => {
                return (
                    <RenderCount data={data} loadFromAPI={loadFromAPI} />
                )
            }}
        />
    )
}
export default Count;